import { render, staticRenderFns } from "./WireInstructionModal.vue?vue&type=template&id=8e3f13dc&scoped=true&"
import script from "./WireInstructionModal.vue?vue&type=script&lang=js&"
export * from "./WireInstructionModal.vue?vue&type=script&lang=js&"
import style0 from "./WireInstructionModal.vue?vue&type=style&index=0&id=8e3f13dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3f13dc",
  null
  
)

export default component.exports